var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbSpare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6a2 2 0 114 0m-6 8h7M8.983 12.35c-.342-.747.025-1.634.79-1.903a6.103 6.103 0 012.017-.353c.977 0 1.905.233 2.715.643C16.573 9.637 19.41 9 22.044 9 29.412 9 35 14.109 35 20.25c0 2.594-1.066 4.86-2.852 6.742a1.388 1.388 0 00-.291.459l-1.721 5.66a1.364 1.364 0 01-1.272.889H25.66a1.37 1.37 0 01-1.338-1.122l-.232-1.755A1.37 1.37 0 0022.753 30h-2.347c-.651 0-1.213.471-1.338 1.123l-.157 1.755A1.37 1.37 0 0117.573 34h-3.091c-.595 0-1.12-.393-1.3-.97l-1.17-4.379a1.367 1.367 0 00-.876-.901C9.442 27.192 5 25.031 5 22.48v-2.53c0-1.66 1.268-3.03 2.911-3.245a1.3 1.3 0 00.819-.471l.746-.9a1.41 1.41 0 00.194-1.483l-.687-1.501z",
    stroke: "#A5E1D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCustomDnbSpare;